module.exports = __webpack_public_path__ + "img/wir-ebzler-logo.72c4890.png";